// src/pages/ZezeninBahcesiPage.jsx
import React from 'react';
import TopBar from '../components/TopBar';
import NavBar from '../components/NavBar';
import ZezeSection from '../components/ZezeSection';
import Footer from '../components/Footer';

export default function ZezeninBahcesiPage() {
  return (
    <>
      <TopBar />
      <NavBar />
      <ZezeSection /> 
      <Footer />
    </>
  );
}
